import { Formik } from "formik";
import { useTranslation } from "react-i18next";
import { FuenteEfluenteLiquidoSchema } from "../data/FuenteEfluenteLiquidoSchema";
import Grid from "./layout/Grid";
import Panel from "./layout/Panel";
import Label from "./controls/Label";
import Row from "./layout/Row";
import Col from "./layout/Col";
import TextField from "./controls/TextField";
import CheckboxField from "./controls/CheckboxField";
import { isInvalid } from "../utils/forms";
import AmmountField from "./controls/AmmountField";
import TextareaField from "./controls/TextareaField";
import Pagination from "./controls/Pagination";
import Button from "./controls/Button";

export function FuenteEfluenteLiquidoForm({
  value,
  page,
  pages,
  select,
  append,
  replace,
  remove,
  operacionesUnitarias,
  unidadCaudalMedio,
  disabled,
}) {
  const { t } = useTranslation();
  return (
    <Formik
      initialValues={value}
      enableReinitialize={true}
      validateOnChange={true}
      validationSchema={FuenteEfluenteLiquidoSchema}
      onSubmit={(values) => {
        if (page === -1) {
          append(values);
        } else {
          replace(values, page);
        }
      }}
    >
      {(fuenteEfluenteLiquidoForm) => (
        <Grid as={<Panel />} className="formulario embebido">
          <Label>{t("fuenteEfluenteLiquidoForm.titulo")}</Label>
          <Row>
            <Col>
              <TextField
                id="fuenteEfluenteLiquido_nombre"
                name="nombre"
                label={t("fuenteEfluenteLiquido.nombre")}
                value={fuenteEfluenteLiquidoForm.values.nombre}
                maxLength={100}
                onChange={(event) =>
                  fuenteEfluenteLiquidoForm.handleChange(event)
                }
                isInvalid={isInvalid("nombre", fuenteEfluenteLiquidoForm)}
                error={t(fuenteEfluenteLiquidoForm.errors.nombre)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <CheckboxField
                id="fuenteEfluenteLiquido_operacionesUnitarias"
                name="operacionesUnitarias"
                label={t("fuenteEfluenteLiquido.operacionesUnitarias")}
                value={fuenteEfluenteLiquidoForm.values.operacionesUnitarias}
                onChange={(event) =>
                  fuenteEfluenteLiquidoForm.handleChange(event)
                }
                options={operacionesUnitarias}
                labelAttr="nombre"
                valueAttr="orden"
                lg={6}
                isInvalid={isInvalid(
                  "operacionesUnitarias",
                  fuenteEfluenteLiquidoForm,
                )}
                error={t(fuenteEfluenteLiquidoForm.errors.operacionesUnitarias)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col lg={4}>
              <AmmountField
                id="fuenteEfluenteLiquido_caudalMedio"
                name="caudalMedio"
                label={t("fuenteEfluenteLiquido.caudalMedio")}
                value={fuenteEfluenteLiquidoForm.values.caudalMedio}
                unit={unidadCaudalMedio}
                max={1000000000}
                onChange={(event) =>
                  fuenteEfluenteLiquidoForm.handleChange(event)
                }
                isInvalid={isInvalid("caudalMedio", fuenteEfluenteLiquidoForm)}
                error={t(fuenteEfluenteLiquidoForm.errors.caudalMedio)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row>
            <Col>
              <TextareaField
                id="fuenteEfluenteLiquido_destino"
                name="destino"
                label={t("fuenteEfluenteLiquido.destino")}
                value={fuenteEfluenteLiquidoForm.values.destino}
                onChange={(event) =>
                  fuenteEfluenteLiquidoForm.handleChange(event)
                }
                rows={12}
                maxLength={1024}
                isInvalid={isInvalid("destino", fuenteEfluenteLiquidoForm)}
                error={t(fuenteEfluenteLiquidoForm.errors.destino)}
                disabled={disabled}
              />
            </Col>
          </Row>
          <Row style={{ display: "flex", flexWrap: "wrap" }}>
            <Col lg={6}>
              <Pagination
                sm
                page={page}
                pages={pages}
                onChange={(event) => select(event.target.value)}
              />
            </Col>
            <Col lg={6}>
              <span
                style={{
                  float: "right",
                  alignContent: "center",
                }}
              >
                {page !== -1 && (
                  <Button
                    sm
                    variant="success"
                    value={t("fuenteEfluenteLiquidoForm.nuevo")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(-1);
                    }}
                    disabled={disabled}
                  />
                )}
                {page !== -1 && (
                  <Button
                    sm
                    variant="danger"
                    value={t("fuenteEfluenteLiquidoForm.eliminar")}
                    onClick={(event) => {
                      event.preventDefault();
                      remove(page);
                    }}
                    disabled={disabled}
                  />
                )}
                <Button
                  sm
                  variant="primary"
                  value={t("fuenteEfluenteLiquidoForm.guardar")}
                  onClick={(event) => {
                    event.preventDefault();
                    fuenteEfluenteLiquidoForm.submitForm();
                  }}
                  disabled={disabled}
                />
                {page === -1 && pages > 0 && (
                  <Button
                    sm
                    variant="default"
                    value={t("fuenteEfluenteLiquidoForm.cancelar")}
                    onClick={(event) => {
                      event.preventDefault();
                      select(0);
                    }}
                    disabled={disabled}
                  />
                )}
              </span>
            </Col>
          </Row>
        </Grid>
      )}
    </Formik>
  );
}
